import React, { useEffect } from "react";
import SocialFb from "../components/service/SocialFb";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const SocialFacebook = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="
                    Facebook Ads Services in Chennai,
                    Facebook Advertising Agency in Chennai,
                    Facebook Ads Expert,
                    Facebook Marketing Services in Chennai,
                    Facebook Ad Campaign Management,
                    Best Facebook Ads Company in Chennai,
                    Facebook PPC Services,
                    Facebook Ads for Lead Generation,
                    Facebook Retargeting Ads,
                    Facebook Ads agency in Chennai,
                    Best Facebook Ads agency in Tamil Nadu,
                    facebook advertising companies,
                    Facebook Ads expert Chennai,
                    social media marketing company Chennai,
                    social media marketing company India,
                    facebook ads service Chennai,
                    facebook ads service India,
                    instagram ads agency Chennai,
                    instagram ads agency India,
                    social media advertising Chennai,
                    social media advertising India,
                    social media management Chennai,
                    social media management India,
                    best social media agency for business Chennai,
                    best social media agency for business India,
                    online brand promotion Chennai,
                    online brand promotion India,
                    facebook business marketing Chennai,
                    facebook business marketing India
                    "
        />
        <title>Social Media Marketing Services | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Boost your brand with expert social media marketing services. Drive engagement, leads, and conversions using targeted Facebook & Instagram strategies."
        />
      </Helmet>
      <div>
        <Navbar />
        <SocialFb />
        <Footer />
      </div></>

  );
};

export default SocialFacebook;
